import { Link } from 'react-router-dom';

export default function AstoriaHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/c9ccc4fbd5eba60b001ebc1f79776925.jpg')] bg-cover bg-center opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Used Cars in Astoria That Won't Rust Out in Two Winters
          </h1>
          <p className="text-xl sm:text-2xl text-slate-200 mb-8 leading-relaxed">
            We're 10 minutes up the road in Warrenton. We know what the salt air does to undercarriages. Every vehicle we sell is inspected for coastal durability — because "low miles" means nothing if the frame's already Swiss cheese.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-car-line text-xl"></i>
              Browse Coastal-Ready Inventory
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              Call Us
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">10 min</div>
              <div className="text-sm text-slate-300">From Downtown Astoria</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">100%</div>
              <div className="text-sm text-slate-300">Undercarriage Inspected</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">$0</div>
              <div className="text-sm text-slate-300">Dealer Markup Games</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
